import {createSvgIcon} from '../create-svg-icon';

export const MinimizeIcon = createSvgIcon(
  <path d="M6 19h12v2H6v-2z" />
, 'MinimizeOutlined');
